module.exports = __webpack_public_path__ + "media/images/team/SNiko-f9ccf8620c60c0a37fe71ac743b93013.jpg";